import { getWeek, getYear, nextDeliveryWeekDateObj } from "@chef/helpers";
import { useCalendarQuery } from "@chef/state-management";

export const useMyAccountCalendarQuery = () => {
  const nextDeliveryWeek = nextDeliveryWeekDateObj();
  const nextWeek = getWeek(nextDeliveryWeek);
  const nextWeeksYear = getYear(nextDeliveryWeek);

  return useCalendarQuery({
    week: nextWeek,
    year: nextWeeksYear,
    range: 12,
  });
};
